import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import DetailsScreen from "../DetailsScreen";
import {typeExport} from "../../../../../redux/store/type";
import store from "../../../../../redux/store";

const mapStateToProps = (state) => ({
    results: state.reducerDetailsScreen.results,
    isLoading: state.reducerDetailsScreen.isLoading,
    NoInternetDialog: state.reducerDetailsScreen.NoInternetDialog,

    resultsSet: state.reducerDetailsScreen.resultsSet,
    isLoadingSet: state.reducerDetailsScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerDetailsScreen.NoInternetDialogSet,

    position: state.reducerDetailsScreen.position,
    id_category: state.reducerDetailsScreen.id_category,


    positionPersonnel: state.reducerDetailsScreen.positionPersonnel,
    id_Personnel: state.reducerDetailsScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetDetailsScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetDetailsScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }

    var config = {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        responseType: 'blob'
    };
    console.log("params", params);

    axios(
        {
            // url: baseUrl + url + params,
            // url: url+"&after=0000-00-00" ,
            url: typeExport.baseUrlWP + url,
            method: typeConnection,
            params: params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: typeExport._TIMEOUT,
            /*      headers: {'X-Requested-With': 'XMLHttpRequest'},*/
        }
    ).then(response => {
        let data = response.data;
        switch (type) {
            case typeExport.TypeGetDetailsScreen:
                //if (response.data.status === true) {
                // dispatch(serviceActionSuccess(data, token, response.data.user));
                if (response.data.status === true) {
                    dispatch(serviceActionSuccess(data));
                }
                else {
                    dispatch(serviceActionError(response))
                }
                //   NavigationService.navigatereset('MainStack');
                // }
                // else {
                //  //   NavigationService.navigatereset('LoginStack');
                // }
                break;

            case typeExport.TypeSetDetailsScreen:

                break;

            default:
        }
    }).catch((e) => {

        switch (type) {
            case typeExport.TypeGetDetailsScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetDetailsScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token) => {
    return dispatch => {

        // if (Platform.OS === 'ios') {
        //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        //             if (isConnected) {
        //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //             }
        //             else {
        //                 dispatch(serviceActionError("No Internet Connection"));
        //             }
        //         }
        //     );
        // }
        // else {
        // NetInfo.isConnected.fetch().then((isConnected) => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //     }
        //     else {
        //         switch (type) {
        //
        //             case typeExport.TypeGetDetailsScreen:
        //                 dispatch(serviceActionError("no connect"));
        //                 break;
        //             default:
        //         }
        //     }
        // });

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        }
        else {
            switch (type) {
                case typeExport.TypeGetDetailsScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetDetailsScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

        //}

        /* NetInfo.getConnectionInfo().done(
             (isConnected) => {
                 if (isConnected) {
                     getDataDisatch(dispatch, url, params, type, typeConnection, token);
                 }
                 else {
                     switch (type) {

                         case typeExport.TypeGetDetailsScreen:
                             dispatch(serviceActionError("no connect"));
                             break;
                         default:
                     }
                 }
             }
         )*/
    }
}


export const serviceActionPending = () => ({
    type: typeExport.DetailsScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.DetailsScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.DetailsScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.DetailsScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.DetailsScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.DetailsScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.DetailsScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(DetailsScreen);
